import { Platform } from '@/types/platform'

const ENABLED_GOODS_WIDGET = [
  Platform.cosmo,
  Platform.goodhouse,
  Platform.esquire,
  Platform.mhealth,
  Platform.popmech,
]

export { ENABLED_GOODS_WIDGET }
